/* Hook encargado de hacer la consulta a la base y 
traer los negocios )deals)

Autor: Benjamín León
Fecha: 2024-11-09
*/
import { useState } from 'react'

import { customFetch } from '../utils/customFetch.ts'
import { Salenote } from '../interfaces/Salenote.ts'

import { makeUrlSalenotesDeal } from './connectionData.tsx'

const useSalenotesDealFetcher = () => {
  const [errorSalenotesDeal, setErrorSalenotesDeal] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const fetchSalenotesDeal = async (vehId: string, cliId: string) => {
    setLoading(true)

    const params = new URLSearchParams({
      vehId: vehId,
      cliId: cliId,
    })

    try {
      const apiUrl = makeUrlSalenotesDeal(params)
      const array = await customFetch<Salenote[]>(apiUrl)

      setErrorSalenotesDeal(null)

      return array
    } catch (err) {
      // Assert the error as an instance of Error
      const myErr = err instanceof Error ? err : new Error('An unknown error occurred')
      setErrorSalenotesDeal(myErr)

      return []
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorSalenotesDeal, loading, fetchSalenotesDeal }
}
export default useSalenotesDealFetcher
